<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Descrição Grupo do Produto', 'Comissão', 'Premio Bruto', 'Premio Líquido', 'Fim de Vigência Apólice', 'Número Apólice', 'Descrição do tipo da Proposta']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoGrupoProduto"/>
        <TableColumn :IsText="true" :status="1" :value="obj.valorComissao ? formatValue(obj.valorComissao) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorPremioBruto ? formatValue(obj.valorPremioBruto) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorPremioLiquido ? formatValue(obj.valorPremioLiquido) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataFimVigenciaApolice)" />
        <TableColumn :IsText="true" :status="1" :value="obj.numeroApolice" />
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoTipoProposta" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import InsuranceWalletRepository from '@/shared/http/repositories/business/insurancewallet.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'AverageBalanceCCO',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadInsuranceWallet(this.document)
      }
    },
    onLoadInsuranceWallet (document) {
      loading.push()
      this.document = document
      InsuranceWalletRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/insurancewallet.vue